import { ErrorBoundary as SharedErrorBoundary } from "@design-system/index";
import type { ReactNode } from "react";

export function ErrorBoundary({ children }: { children: ReactNode }) {
  return <SharedErrorBoundary context="Design Lab">{children}</SharedErrorBoundary>;
}
